import React, { useEffect, useImperativeHandle, useState } from "react";
import { Button, Input } from "./Elements";
import Modal from "./Modal";
import { toast } from "react-toastify";
import commonNetwork from "../../common/api/commonNetwork";


const ResetPasswordModal = React.forwardRef(({ }, ref) => {

    const [isVisible, setIsVisible] = useState(false);
    const [fields, setFields] = useState({
        oldPassword: "",
        newPassword: "",
        newPasswordAgain: ""
    });
    useImperativeHandle(ref, () => ({

        openModal() {

            setIsVisible(true);
        },
        hideModal() {
            setIsVisible(false);
        }

    }));

    useEffect(() => {
        if (!isVisible) {
            setFields({
                oldPassword: "",
                newPassword: "",
                newPasswordAgain: ""
            })
        }
    }, [isVisible]);


    const changePasswordConfirm = async () => {

        if (fields.newPassword?.length == 0 || fields.newPasswordAgain?.length == 0 || fields.oldPassword?.length == 0) {
            toast.error("Lütfen tüm alanları doldurunuz");
            return;
        }

        if (fields.newPassword.length < 6) {
            toast.error("Şifre en az 6 karakter uzunluğunda olmalıdır");
            return;
        }

        const hasLetterLower = /[a-z]/.test(fields.newPassword);
        const hasLetterUpper = /[A-Z]/.test(fields.newPassword);
        const hasNumber = /[0-9]/.test(fields.newPassword);
        const hasSpecialChar = /[!@#$%^&*()_+={}\[\]:;"'<>,.?/\\|]/.test(fields.newPassword);

        if (!hasLetterLower || !hasLetterUpper || !hasNumber || !hasSpecialChar) {
            toast.error("Şifre büyük-küçük harf, sayı ve özel karakter içermelidir.");
            return; // İşlemi burada kes
        }

        if (fields.newPassword != fields.newPasswordAgain) {
            toast.error("Girdiğiniz şifreler aynı olmalıdır.");
            return;
        }

        const params = {
            OldPassword: fields.oldPassword,
            Password: fields.newPassword
        }
        const { isSuccess, errorMessage } = await commonNetwork.post("/user/update-password", params);

        if (isSuccess) {
            toast.success("Şifreniz başarılı bir şekilde güncellendi.");

            setIsVisible(false);
        } else {
            toast.error(errorMessage);
        }
    }
    const onChangeField = (event: any) => {


        setFields({
            ...fields,
            [event.target.name]: event.target.value
        });
    }


    return (
        <Modal openModal={isVisible} setOpenModal={setIsVisible}>
            <div>
                <div className="sm:flex sm:items-start">
                    <div className="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left w-full">
                        <h3 className="text-md leading-6 font-medium text-gray-900">
                            {"Şifremi Değiştir"}
                        </h3>

                        <div className="w-full mb-5">
                            <div className="mt-4">
                                <Input
                                    name="oldPassword"
                                    value={fields.oldPassword}
                                    type="password"
                                    className="w-[100%]"
                                    label="Eski Şifre"
                                    onChange={onChangeField}
                                    required
                                />
                            </div>
                            <div className="mt-4">
                                <Input
                                    name="newPassword"
                                    value={fields.newPassword}
                                    type="password"
                                    className="w-[100%]"
                                    label="Yeni Şifre"
                                    onChange={onChangeField}
                                    required
                                />
                            </div>
                            <div className="mt-4">
                                <Input
                                    name="newPasswordAgain"
                                    value={fields.newPasswordAgain}
                                    type="password"
                                    className="w-[100%]"
                                    label="Yeni Şifre Tekrar"
                                    onChange={onChangeField}
                                    required
                                />
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-5 sm:mt-4 flex justify-end space-x-2">
                    <Button
                        color="gray"
                        hover="gray"
                        size="xs"
                        callback={() => setIsVisible(false)}
                    >
                        {"İptal"}
                    </Button>
                    <Button
                        color="primary"
                        hover="primary"
                        size="xs"
                        callback={changePasswordConfirm}
                    >
                        {"Kaydet"}
                    </Button>
                </div>
            </div>
        </Modal>
    );
})
export default ResetPasswordModal;